<template>
  <component
    v-bind="bindAttrs"

    :is="type"
    :target="target"
    class="c-link"
    v-on="componentListeners"
    @click="$emit('click', $event)"
  >
    <slot />
  </component>
</template>

<script>
import useVue3Migration from '@convenia/composables/useVue3Migration'

/**
 * Generic link component.
 */
export default {
  name: 'CLink',
  inheritAttrs: false,

  emits: [ 'click' ],

  props: {
    /**
     * The link's path, can be either an external URL or the path to an
     * internal route in the app (must follow the vue-router api).
     */
    to: {
      type: [ String, Object ],
      default: () => null
    },
    /**
     * Whether the link is external or not
     */
    external: {
      type: Boolean,
      default: false
    },

    /**
     * Whether to use the nuxt component for route links.
     */
    nuxt: {
      type: Boolean,
      default: false
    }
  },

  setup: (_, ctx) => useVue3Migration(ctx),

  computed: {
    target () {
      if (this.$attrs.target) return this.$attrs.target

      if (this.isVue2) return this.external && '_blank'
      return this.external ? '_blank' : null
    },

    type () {
      return !this.to
        ? 'button' : this.external
          ? 'a' : this.nuxt
            ? 'nuxt-link' : 'router-link'
    },

    bindAttrs () {
      const link = this.type === 'a' || this.type === 'button'
        ? { href: this.external && this.to }
        : { to: this.to || null }

      return { ...this.$attrs, ...link }
    }
  }
}
</script>
